import React, { useEffect, useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import { useAuthStore } from '../../store/authStore';
import { getAdminMe } from '../../api';

export default function AdminLayout() {
  const { isAuthenticated, token, setAuth, logout } = useAuthStore();
  const [checking, setChecking] = useState(!!token);

  useEffect(() => {
    if (!token) {
      setChecking(false);
      return;
    }
    let cancelled = false;
    getAdminMe()
      .then((res) => {
        if (cancelled) return;
        const admin = res.data?.data?.admin || res.data?.data;
        if (admin) setAuth(token, admin);
      })
      .catch(() => {
        if (!cancelled) logout();
      })
      .finally(() => {
        if (!cancelled) setChecking(false);
      });
    return () => { cancelled = true; };
  }, [token, setAuth, logout]);

  if (!isAuthenticated && !checking) return <Navigate to="/login" replace />;
  if (checking) {
    return (
      <div className="flex h-screen items-center justify-center bg-cream-100 text-ink/60 text-sm">
        Checking session…
      </div>
    );
  }

  return (
    <div className="flex h-screen overflow-hidden bg-cream-100">
      <Sidebar />
      <div className="flex-1 overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
}
